<template>
  <div
    class="cell"
    :class="[{ 'cell-active': isActive }, { 'cell-disabled': isDisable }]"
    @click="cellClick()"
  >
    <img v-if="hasImg" class="cell-img" :src="prop.img_url" alt="" />
    <span class="cell-name">{{ prop.propValue }}</span>
    <!-- <SfButton class="cell-name"> {{ prop.propValue }} </SfButton> -->
  </div>
</template>

<script>
import { SfButton } from '@storefront-ui/vue';
export default {
  name: 'specItem',
  props: {
    prop: {
      type: Object
    },
    allSku: {
      type: Array,
      default: []
    },
    pid: {
      type: Number
    },
    seletedSku: {
      type: Object
    }
  },
  data() {
    return {
      valueId: this.prop.valueId
    };
  },
  components: {
    SfButton
  },
  computed: {
    isActive() {
      return (
        this.seletedSku[this.pid] &&
        this.valueId === this.seletedSku[this.pid].valueId
      );
    },
    hasImg() {
      return Boolean(this.prop.image);
    },
    isDisable() {
      return !this.allSku.some((val) => {
        return val === this.getMySku;
      });
    },
    getMySku() {
      const mySku = [];
      // 自己和其他fence内已选的cell 来确认自己的sku
      for (const k in this.seletedSku) {
        const cell = this.seletedSku[k];
        if (String(k) === String(this.pid)) {
          // 当前行设为本cell的prop
          mySku.push(k + ':' + this.valueId);
        } else if (cell) {
          // 获取其他行已选cell
          mySku.push(k + ':' + cell.valueId);
        }
      }
      return mySku.flat().join(';');
    }
  },
  methods: {
    cellClick() {
      if (this.valueId === this.seletedSku[this.pid].valueId) {
        this.$emit('cellClike', this.pid, '');
      } else {
        this.$emit('cellClike', this.pid, this.prop);
      }
    }
  }
};
</script>

<style scoped>
.cell {
  position: relative;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  min-width: 40px;
  margin: 0 12px 12px 0;
  overflow: hidden;
  color: #323233;
  font-size: 13px;
  line-height: 16px;
  vertical-align: middle;
  border-radius: 4px;
  cursor: pointer;
}
.cell::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f7f8fa;
  content: "";
}
.cell-name {
  z-index: 0;
  padding: var(--button-padding, var(--spacer-sm) var(--spacer-base));
  width: var(--button-size, var(--button-width));
  height: var(--button-size, var(--button-height));
  font: var(--button-font, var(--button-font-weight, var(--font-weight--semibold)) var(--button-font-size, var(--font-size--base))/var(--button-font-line-height, 1.2) var(--button-font-family, var(--font-family--secondary)));
}
.cell-img {
  z-index: 1;
  width: 24px;
  height: 24px;
  margin: 4px 0 4px 4px;
  object-fit: cover;
  border-radius: 2px;
}
.cell-active {
  color: var(--button-background, var(--c-primary));
  border: 1px solid var(--button-background, var(--c-primary));
}
.cell-active::before {
  background: currentColor;
  opacity: 0.1;
}
.cell-disabled {
  pointer-events: none;
  color: #c8c9cc;
  background: #f2f3f5;
  cursor: not-allowed;
}
</style>
